import { WrapPresentation } from '../ui/presentation'
import '../styles/pages/presentation.css'

export const PresentationPage = () => {
  return (
    <div className='presentation-page'>
        {/* <img src="https://placehold.co/600x400" alt="Placeholder" className='presentation-background-img' /> */}
        {/* <h1>Travel Center Guatemala</h1> */}
        <WrapPresentation />
    </div>
  )
}
